<page-header>
  <a [routerLink]="subsidiariesRoutePath" page-header-area="button" data-cy="PageHeaderButton" class="btn-link" translate="Actions.BackToSubsidiaries" data-testid="BackToSubsidiaries"></a>
</page-header>

<div class="content-block has-padding"
  [class.block-loader]="(subsidiaryFormLoader.isLoading$ | async) || (subsidiaryFromLegalIdentifierLoader.isLoading$ | async) || (subsidiaryBlockedFormLoader.isLoading$ | async)">
  <loader-spinner [model]="subsidiaryFormLoader"/>
  <loader-spinner [model]="subsidiaryFromLegalIdentifierLoader"/>
  <loader-spinner [model]="subsidiaryBlockedFormLoader"/>

  <form [formGroup]="form" (submit)="onSubmit()" autocomplete="off">
    <div class="row">
      <div class="col-6">
        @if (countries$ | async; as countries) {
          <div class="form-group">
            <label class="form-label form-label-required" translate="NewAccount.Company.Country"></label>
            <ng-select
              [items]="countries"
              formControlName="countryCode"
              bindValue="countryCode"
              bindLabel="countryName"
              [minTermLength]="3"
              class="ng-select-custom ng-select-custom-alt"
              [class.is-invalid]="countryCodeField.dirty && countryCodeField.invalid"
              notFoundText="{{ 'Forms.FieldErrorMessages.NoResult' | translate }}"
              typeToSearchText="{{ 'Actions.Search' | translate }}"
              placeholder="{{ 'Forms.SelectDefault' | translate }}"
              />
            <form-control-feedback [field]="countryCodeField"/>
          </div>
        }
      </div>
      <div class="col-6">
        <div class="form-group">
          <label class="form-label"
            [class.form-label-required]="isFrance"
          for="field-legalIdentifier">{{ (isFrance ? 'NewAccount.Company.Siret' : 'NewAccount.Company.Identifier') | translate }}</label>
          <input type="text" autocomplete="off" class="form-control form-control-alt" id="field-legalIdentifier"
            [mask]="legalIdentifierMask" formControlName="legalIdentifier"
            [class.is-invalid]="legalIdentifierField.dirty && legalIdentifierField.invalid"/>
          <form-control-feedback [field]="legalIdentifierField"/>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <div class="form-group">
          <label class="form-label form-label-required" for="field-name" translate="NewAccount.Company.Name"></label>
          <input type="text" autocomplete="off" class="form-control form-control-alt" id="field-name"
            formControlName="name" [class.is-invalid]="nameField.dirty && nameField.invalid"/>
          <form-control-feedback [field]="nameField"/>
        </div>
      </div>

      <div class="col-6">
        <div class="form-group">
          <label class="form-label form-label-required" for="field-address" translate="NewAccount.Company.Street"></label>
          <input type="text" autocomplete="off" class="form-control form-control-alt" id="field-address"
            formControlName="street" [class.is-invalid]="streetField.dirty && streetField.invalid"/>
          <form-control-feedback [field]="streetField"/>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <div class="form-group">
          <label class="form-label form-label-required" for="field-zip-code" translate="NewAccount.Company.ZipCode"></label>
          <input type="text" autocomplete="off" class="form-control form-control-alt" id="field-zip-code"
            formControlName="zipCode" [class.is-invalid]="zipCodeField.dirty && zipCodeField.invalid"/>
          <form-control-feedback [field]="zipCodeField"/>
        </div>
      </div>

      <div class="col-6">
        <div class="form-group">
          <label class="form-label form-label-required" for="field-city" translate="NewAccount.Company.City"></label>
          <input type="text" autocomplete="off" class="form-control form-control-alt" id="field-city"
            formControlName="city" [class.is-invalid]="cityField.dirty && cityField.invalid"/>
          <form-control-feedback [field]="cityField"/>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-6">
        <div class="form-group">
          <label class="form-label form-label-required" for="field-accounting-documents"
          translate="NewAccount.Company.AnnualAccountingDocumentCount"></label>
          <ng-select
            formControlName="annualAccountingDocumentCount"
            class="ng-select-custom ng-select-custom-alt"
            [class.is-invalid]="annualAccountingDocumentCountField.dirty && annualAccountingDocumentCountField.invalid"
            notFoundText="{{ 'Forms.FieldErrorMessages.NoResult' | translate }}"
            typeToSearchText="{{ 'Actions.Search' | translate }}"
            placeholder="{{ 'Forms.SelectDefault' | translate }}"
            >
            @for (key of annualAccountingDocumentCountKeys; track key) {
              <ng-option [value]="annualAccountingDocumentCount[key]">
                {{ 'NewAccount.Company.AccountingDocumentCount.' + key | translate }}
              </ng-option>
            }
          </ng-select>
          <form-control-feedback [field]="annualAccountingDocumentCountField"/>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="form-group">
          <label class="form-label form-label-required" for="field-currency-code"
          translate="NewAccount.Company.CurrencyCode"></label>
          <ng-select
            [items]="currencies$ | async"
            formControlName="currencyCode"
            bindValue="currencyCode"
            bindLabel="currencyName"
            class="ng-select-custom ng-select-custom-alt"
            [class.is-invalid]="currencyCodeField.dirty && currencyCodeField.invalid"
            notFoundText="{{ 'Forms.FieldErrorMessages.NoResult' | translate }}"
            typeToSearchText="{{ 'Actions.Search' | translate }}"
            placeholder="{{ 'Forms.SelectDefault' | translate }}"
            />
          <form-control-feedback [field]="currencyCodeField"/>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-6">
        <div class="form-group">
          <label class="form-label form-label-required" for="field-annual-figure"
          translate="NewAccount.Company.AnnualFigure"></label>
          <div class="input-group">
            <input type="text" currencyMask autocomplete="off" class="form-control form-control-alt"
              id="field-annual-figure" formControlName="annualFigure"
              [class.is-invalid]="annualFigureField.dirty && annualFigureField.invalid"/>
            @if (currencySymbol$ | async; as symbol) {
              <div class="input-group-append">
                <span class="input-group-text">{{ symbol }}</span>
              </div>
            }
          </div>
          <form-control-feedback [field]="annualFigureField"/>
        </div>
      </div>
      <div class="col-lg-6">
        @if (!currentUserIsSupport()) {
          <div class="form-group">
            <div class="form-check">
              <label class="form-label" for="field-salesConditionsAccepted"><br></label>
              <br><input id="field-contact-salesConditionsAccepted" class="form-check-input" type="checkbox" formControlName="salesConditionsAccepted" />
              <label class="form-check-label form-label-required" for="field-contact-salesConditionsAccepted">{{ 'NewAccount.Company.AcceptSalesConditions' | translate }} <a (click)="openSalesConditions($event)" href="#" translate="NewAccount.Company.AcceptSalesConditionsLink"></a></label>
              <form-control-feedback [field]="salesConditionsAcceptedField"/>
            </div>
          </div>
        } @else {
          <div class="form-group">
            <label class="form-label" for="field-timezone" translate="NewAccount.Timezone"></label>
            <ng-select
              [items]="timezoneOptions()"
              [clearable]="false"
              formControlName="timezone"
              class="ng-select-custom ng-select-custom-alt"
              />
          </div>
        }
      </div>
    </div>

    <div class="row">
      <div class="col-lg-6">
        <div class="form-group">
          <label class="form-label" for="field-logo">
            {{ 'NewAccount.Company.Logo' | translate }}
            <i class="far fa-info-circle" ngbTooltip="{{ 'NewAccount.Company.LogoTooltip' | translate }}"></i>
          </label>
          <div class="row">
            <file-upload class="col-lg-6" formGroupName="logo"
              [form]="logoField"
              [config]="fileConfig"
              [delegateUpload]="false"
              buttonKey="NewAccount.Company.UploadFile"
              />
            <file-upload-instructions [config]="fileConfig" class="col-lg-6"/>
          </div>
          <form-control-feedback [field]="logoField"/>
        </div>
      </div>
      @if (currentUserIsSupport()) {
        <div class="col-lg-6">
          <div class="form-group">
            <label class="form-label" for="field-databaseTarget" translate="NewAccount.Database"></label>
            <ng-select
              [items]="databaseOptions()"
              [clearable]="false"
              formControlName="databaseTarget"
              bindLabel="name"
              class="ng-select-custom ng-select-custom-alt"
              />
          </div>
        </div>
      }
      @if (currentUserIsSupport()) {
        <div class="col-lg-6"></div>
        <div class="col-lg-6">
          <div class="form-group">
            <label class="form-label" for="field-brandingCode" translate="NewAccount.Branding"></label>
            <ng-select
              [items]="brandings()"
              [clearable]="false"
              formControlName="brandingCode"
              bindLabel="name"
              bindValue="code"
              class="ng-select-custom ng-select-custom-alt"
              />
          </div>
        </div>
      }
    </div>

    <div class="form-text" translate="Forms.RequiredFields"></div>

    <div class="form-actions form-actions-spaced">
      <button (click)="onCancel()" class="btn btn-light" type="button" translate="Actions.Cancel" data-cy="Cancel"></button>
      <button [disabled]="form.invalid || form.pending || (subsidiaryIsLoading$ | async)"
      class="btn btn-primary" type="submit" translate="Actions.CreatePlatform" data-cy="CreatePlatform"></button>
    </div>
  </form>
</div>
